import { render, staticRenderFns } from "./productLabel.vue?vue&type=template&id=3bf1a628"
import script from "./productLabel.vue?vue&type=script&lang=js"
export * from "./productLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports